/*! Version: b91cd8f9 */
webpackJsonp([5],{

/***/ 1:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);

__webpack_require__(12);

__webpack_require__(101);

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"breakpointSmall":"767px","breakpointMedium":"1023px"};

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Defer until launch
(0, _jquery2.default)(function () {
  (0, _jquery2.default)('.c-section-nav__link--top').click(function () {
    (0, _jquery2.default)('html, body').animate({ scrollTop: 0 }, 'slow');
  });
}); // Content page specific styles

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Behavior specific to the sidenav in content pages and featured scrolls


/***/ })

},[100]);


// WEBPACK FOOTER //
// js/content-page.js